import { render, staticRenderFns } from "./HomeType10.vue?vue&type=template&id=0a375182&scoped=true&"
import script from "./HomeType10.vue?vue&type=script&lang=js&"
export * from "./HomeType10.vue?vue&type=script&lang=js&"
import style0 from "./HomeType10.vue?vue&type=style&index=0&id=0a375182&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a375182",
  null
  
)

export default component.exports